import { register } from './message-router';
import { socketManager } from './network';

// Handle incoming 'info' messages
const clientVerEl = document.getElementById('client-ver') as HTMLElement;
const agentVerEl = document.getElementById('agent-ver') as HTMLElement;

register('info', (data: { mode: string; ver: string }) => {
  const modeInput = document.querySelector<HTMLInputElement>(
    `input[name="mode"][value="${data.mode}"]`
  );
  if (modeInput) {
    modeInput.checked = true;
  }
  if (agentVerEl) {
    agentVerEl.textContent = `v${data.ver}`;
    console.log(`Agent version: v${data.ver}`);
    console.log(`Client version: ${clientVerEl.textContent}`);
  }
});

// --- Chatbot Logic ---
const chatForm = document.getElementById('chat-form') as HTMLFormElement;
const chatInput = document.getElementById('chat-input') as HTMLInputElement;
const chatHistory = document.getElementById('chat-history') as HTMLElement;

// Listen for mode changes and notify server
document.querySelectorAll<HTMLInputElement>('input[name="mode"]').forEach(radio => {
  radio.addEventListener('change', (e: Event) => {
    const target = e.target as HTMLInputElement;
    socketManager.send('info', { mode: target.value });
  });
});

function appendAIMessage(message: string, before?: HTMLElement): void {
  try {
    const json = JSON.parse(message) as { message: string; command?: string };
    appendMessage('ai', json.message, json.command, '', before);
  } catch {
    appendMessage('ai', message, '', '', before);
  }
}

function appendMessage(role: 'user' | 'ai', text: string, command: string = '', html: string = '', before?: HTMLElement): HTMLDivElement {
  const div = createMessageDiv(role, text, command, html);
  if (before) {
    chatHistory.insertBefore(div, before);
  } else {
    chatHistory.appendChild(div);
  }
  chatHistory.scrollTop = chatHistory.scrollHeight;
  return div;
}

function createMessageDiv(role: 'user' | 'ai', text: string, command: string = '', html: string = ''): HTMLDivElement {
  const div = document.createElement('div');
  const isUser = role === 'user';
  div.className = `p-3 rounded-lg text-md max-w-[90%] [&_pre]:break-words [&_pre]:whitespace-pre-wrap [&_p]:break-words [&_p]:whitespace-pre-wrap ${isUser ? 'bg-blue-900 ml-auto text-white' : 'bg-gray-800 text-gray-300'}`;
  const msgDiv = document.createElement('div');
  msgDiv.innerHTML = html !== '' ? html : marked.parse(text);
  div.appendChild(msgDiv);
  if (command) {
    const cmdPre = document.createElement('pre');
    cmdPre.className = 'mt-2 p-2 text-sm bg-gray-900 text-green-500 cursor-pointer hover:bg-gray-700';
    cmdPre.textContent = command;
    div.appendChild(cmdPre);
    cmdPre.onclick = () => {
      socketManager.send('cmd', command);
    };
  }
  return div;
}

const thinkingMsg: HTMLDivElement[] = [];
let currentChatIndex = 0;

chatForm.addEventListener('submit', async (e: Event) => {
  e.preventDefault();
  const message = chatInput.value.trim();
  if (!message) return;

  // appendMessage('user', message);
  chatInput.value = '';

  socketManager.send('user', [currentChatIndex, message]);
});

// Initial request for chat messages
socketManager.send('user', [currentChatIndex, '']);

register('chat', (data: [number, ...[string, string][]]) => {
  const [index, ...messages] = data;

  if (index > currentChatIndex) {
    // Request missing chat messages
    socketManager.send('user', [currentChatIndex, '']);
    return;
  } else if (index < currentChatIndex) {
    console.error('Received wrong chat messages. Ignoring.');
    return;
  }

  // Drop already processed messages
  for (let i = currentChatIndex - index; i < messages.length; i++) {
    currentChatIndex++;
    const [role, msg] = messages[i];
    if (role === 'ai') {
      let el = thinkingMsg.shift();
      appendAIMessage(msg, el);
      el?.remove();
    } else {
      appendMessage('user', msg);
    }
  }
});

function getSpinnerHTML(message: string): string {
  return `<span class="inline-flex items-center gap-2">${message}<span class="w-5 h-5 border-4 border-gray-600 border-t-blue-500 rounded-full animate-spin"></span></span>`;
}

register('think', () => {
  thinkingMsg.push(appendMessage('ai', '', '', getSpinnerHTML('Thinking...')));
});

export { appendMessage, chatInput, getSpinnerHTML, currentChatIndex };
